import axios from "axios";
import URL from "../../helpers/URL";
import configuration from "./configuration";

export const addFile = (data:any, additionalConfig:any) => {
    const config = {...additionalConfig,...configuration()}
    return axios.post(URL.addVaultFile, data, config)
}

export const getFiles = () => {
    const config = configuration()
    return axios.get(URL.getVaultFiles, config)
}